export const CREATE_SPRAY_EVENT_MODAL = 'createSprayEventModal';
export const EDIT_SPRAY_EVENT_MODAL = 'editSprayEventModal';
export const PRINT_SPRAY_WORKSHEET_MODAL = 'printSprayWorksheetModal';
export const COPY_SPRAY_EVENT_MODAL = 'copySprayEventModal';
export const UNCOMPLETE_SPRAY_EVENT_MODAL = 'uncompleteSprayEventModal';
